import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export const getMePlayers = async () => {
  const { data } = await req(ENDPOINTS.USERS.GET_ME_PLAYERS3())
  return Array.isArray(data) ? data : []
}
